// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1QpNY","legacyBtn":"MutateMid_legacyBtn__4znCp"};